<div class="Home">
  <header class="sticky-top">
    <div class="header_title text-center py-2">
      <span>{{ $t('header.title') }}</span>
      <LanguageSwitcher />
    </div>
  </header>

  <!-- ローディング -->
  <loading v-model:active="loader.is_loading" :is-full-page="loader.is_full_page"></loading>
  <!-- メッセージ -->
  <b-alert v-model="message.is_alert" dismissible :variant="message.variant">{{ message.message }}</b-alert>

  <b-container class="px-0">
    <div class="text-center mt-4 mx-4">
      <div class="markdown-body" v-html="bind_data.markdowntext"></div>
    </div>

    <footer class="sticky-bottom">
      <b-row>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button block variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="home()">{{ $t('nav.about') }}</b-button>
        </b-col>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button block variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="privacy_policy()">{{ $t('nav.privacy_policy') }}</b-button>
        </b-col>
        <b-col class="d-grid gap-2" lg="4" md="12">
          <b-button block variant="outline-primary" class="mt-2 mx-4 btn" size="sm" @click="terms_of_service()">{{ $t('nav.terms_of_service') }}</b-button>
        </b-col>
      </b-row>
      <br>
    </footer>
  </b-container>
  
</div>